/**
 * 系统工具函数
 */
import { publicAxios as axios } from "@/framework/router/axios";

// import { setStore, getStore } from '@/framework/util/store'
/**
 * 获取当前时间戳
 */
const getCurrentTimestamp = () => Date.parse(new Date()) / 1000;

/**
 * 获取常量字典
 * @param {String} cataCode 数据字典编码
 * @param {Number} isAll 是否向下递归
 * @param {Boolean} forcedRefresh 是否强行拉取最新值
 */
export const getDictionary = (cataCode, isAll = 0, forcedRefresh = false) => {
  return new Promise((resolve, rejecct) => {
    // let localCache = getStore({ name: `${cataCode}_${isAll}` })
    let localCache = JSON.parse(
      window.localStorage.getItem(`${cataCode}_${isAll}`)
    );
    let currentTimestamp = getCurrentTimestamp();
    if (
      localCache &&
      currentTimestamp - localCache.setTime <= 60 * 60 * 24 * 7 &&
      !forcedRefresh
    ) {
      localCache.data.forEach(item => Object.freeze(item));
      return resolve(localCache.data);
    } else {
      axios
        .get("/pub/dm-const/listByCataCode", {
          params: {
            cataCode,
            isAll
          }
        })
        .then(res => {
          if (Array.isArray(res.data) && res.data.length) {
            window.localStorage.setItem(
              `${cataCode}_${isAll}`,
              JSON.stringify({
                data: res.data,
                setTime: getCurrentTimestamp()
              })
            );
            // setStore({ name: `${cataCode}_${isAll}`, content: { data: res.data, setTime: getCurrentTimestamp() }})
            res.data.forEach(item => Object.freeze(item));
            return resolve(res.data);
          } else {
            return resolve([]);
          }
        })
        .catch(() => {
          return resolve([]);
        });
    }
  });
};
/**
 * avue表格处理
 * @param {Object} avueOptions  auve 表格配置
 */
export const avueOptionsHandle = avueOptions => {
  delete avueOptions.calcHeight;
  // delete avueOptions.height
  delete avueOptions.index;
  avueOptions.column.forEach(item => {
    // item.display = false
    // item.align = "left";
    // item.sortable = true
    // item.sortable = 'custom'
    // item.minWidth = 250
    item.overHidden = true;
    // if (!item.width || item.width < 300) {
    //   item.width = 300
    // }
  });
  //   avueOptions.size = "mini";
  avueOptions.columnBtn = false;
  avueOptions.menuPosition = "right";
  // avueOptions.searchMenuSpan = 24;

  // return Object.freeze({
  //   ...avueOptions,
  //   size: 'mini'
  // })
  return avueOptions;
};
